import { render } from "./indicadorTreinador.vue?vue&type=template&id=26582a5a&scoped=true"
import script from "./indicadorTreinador.vue?vue&type=script&lang=js"
export * from "./indicadorTreinador.vue?vue&type=script&lang=js"

import "./indicadorTreinador.vue?vue&type=style&index=0&id=26582a5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26582a5a"]])

export default __exports__